module.exports = __webpack_public_path__ + "static/media/stop-13.8614552c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-13.svg
// module id = 1380
// module chunks = 0